<template>
  <v-card class="mt-3" ref="familyMembersCanada">
    <v-card-title>
      <span>{{sectionLabel}}</span>
      <v-spacer />
      <v-btn color="primary" :disabled="!notApplicable" dark small @click.native="saveForm()">Add</v-btn>
    </v-card-title>
    <v-card-text>
      <v-row dense class="mb-3 flex">
        <v-col cols="12">
          <div class="body-2 pull-left">Do you have any other family members currently living in Canada?</div>
          <el-checkbox class="ml-5" v-model="notApplicable" @change="checkApplicable()">Yes</el-checkbox>
        </v-col>
      </v-row>
      <v-alert type="info" border="left" dense class="mb-3" v-if="sectionInfoBox">
        {{sectionInfoBox}}
      </v-alert>
      <el-collapse v-model="activeNames" accordion v-show="notApplicable">
        <el-collapse-item :name="i+1" v-for="(form,i) in items" :key="i">
          <template slot="title">
            <div class="relative">
              <span class="el-col-title">{{form.first_name}} {{form.last_name}}</span>
            </div>
          </template>
          <el-form :model="form" ref="form" label-position="top">
            <v-row dense>
              <v-col cols="12" sm="6" md="4" lg="3">
                <el-form-item label="First Name" prop="first_name">
                  <el-input :id="'first_name' + form.id" v-model="form.first_name" placeholder="First Name" style="width: 100%;" />
                </el-form-item>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <el-form-item label="Middle Name" prop="middle_name">
                  <el-input :id="'middle_name' + form.id" v-model="form.middle_name" placeholder="Middle Name" style="width: 100%;" />
                </el-form-item>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <el-form-item label="Last Name" prop="last_name">
                  <el-input :id="'last_name' + form.id" v-model="form.last_name" placeholder="Last Name" style="width: 100%;" />
                </el-form-item>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <el-form-item label="Relationship to Principal Applicant" prop="relationship">
                  <el-input :id="'relationship' + form.id" v-model="form.relationship" style="width: 100%;" />
                </el-form-item>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <el-form-item label="Date of Birth" prop="date_of_birth">
                  <el-date-picker :id="'date_of_birth' + form.id" value-format="yyyy-MM-dd" :picker-options="datePickerOptions" v-model="form.date_of_birth" v-on:click.native="checkDate($event)" style="width: 100%;"></el-date-picker>
                </el-form-item>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <el-form-item label="Status in the County" prop="status_in_country">
                  <el-input :id="'status_in_country' + form.id" v-model="form.status_in_country" style="width: 100%;" />
                </el-form-item>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <el-form-item label="Province" prop="province_id">
                  <div class="el-select native-select">
                    <div class="el-input">
                      <select :id="'province_id' + form.id" v-model="form.province_id" placeholder="Select" class="el-input__inner">
                        <option v-for="(item, index) in province" v-bind:key="index" :value="item.id" :label="item.province_name">{{ item.province_name }}</option>
                      </select>
                    </div>
                  </div>
                </el-form-item>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <el-form-item label="City" prop="city">
                  <el-input :id="'city' + form.id" v-model="form.city" style="width: 100%" />
                </el-form-item>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <el-form-item label="Address" prop="address">
                  <el-input :id="'address' + form.id" v-model="form.address" style="width: 100%" />
                </el-form-item>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <el-form-item label="Postal code" prop="postal_code">
                  <el-input :id="'postal_code' + form.id" v-model="form.postal_code" style="width: 100%" />
                </el-form-item>
              </v-col>
              <v-col cols="12">
                <v-btn :loading="loading" :disabled="loading" color="primary" small @click.native="submitForm(i,form)">
                  {{ $t('global.save') }}
                </v-btn>
                <v-btn color="error" small @click.native="deleteOpen(form,i)">Delete</v-btn>
              </v-col>
            </v-row>
          </el-form>
        </el-collapse-item>
      </el-collapse>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import datavalidation from '@/mixins/datavalidation.js'

export default {
  props: {
    sectionId: {
      type: String
    },
    sectionSlug: {
      type: String
    },
    sectionLabel: {
      type: String
    },
    sectionInfoBox: {
      type: String
    },
    memberUID: {
      type: String,
      required: true
    },
    memberID: {
      type: String,
      required: true
    },
    datas: {
      type: Array
    }
  },
  mixins: [datavalidation],
  data() {
    return {
      edit: false,
      formItem: {
        application_id: this.$route.params.id,
        member_uid: this.memberUID,
        member_id: parseFloat(this.memberID),
        first_name: null,
        last_name: null,
        middle_name: null,
        date_of_birth: null,
        relationship: null,
        status_in_country: null,
        province_id: null,
        city: null,
        address: null,
        postal_code: null
      },
      activeNames: -1,
      selectProvine: false,
      url: 'imms_table/application_family_members_canada',
      state: 'familyMembersCanada',
      loading: false,
      datePickerOptions: {
        disabledDate(date) {
          return date > new Date()
        }
      }
    }
  },
  watch: {
    memberUID: function() {
      this.fetchData()
    }
  },
  computed: {
    ...mapGetters({
      country: 'other/country',
      province: 'other/province',
      relationships: 'other/relationships',
      applicableId: 'applicable/id'
    }),
    items: {
      get() {
        return this.$store.state.all_stores[this.state]
      }
    },
    notApplicable: {
      get() {
        return this.$store.state.applicable.notApplicable.family_members_canada
      },
      set(val) {
        this.$store.commit('applicable/set_family_members_canada', val)
      }
    }
  },
  mounted() {
    this.fetchData()
    this.$store.dispatch('other/getRelationShips', '?filter=name!=Principal&order=rel_order ASC,name ASC')
    this.$store.dispatch('other/getProvince', 42)
  },
  methods: {
    checkDate: function(event) {
      this.$emit('checkDate', event)
    },
    fetchData() {
      this.$Progress.start()
      var url = 'table/application_family_members_canada?filter=member_uid=' + this.memberUID
      this.$store.dispatch('all_stores/getAll', { 'url': url, 'slug': this.state })
        .then(response => {
          if (this.datas !== undefined) {
            this.checkItemsFields(this.items, this.datas, this.sectionId)

            if (this.notApplicable) {
              $(this.$refs.familyMembersCanada).remove()
            }
          }
          this.$Progress.finish()
        })
        .catch(err => {
          this.$Progress.fail()
        })
    },
    nodeClear() {
      this.formItem = {
        application_id: this.$route.params.id,
        member_uid: this.memberUID,
        member_id: parseFloat(this.memberID),
        first_name: null,
        last_name: null,
        middle_name: null,
        date_of_birth: null,
        relationship: null,
        status_in_country: null,
        province_id: null,
        city: null,
        address: null,
        postal_code: null
      }
      this.edit = false
    },
    saveForm() {
      this.nodeClear()
      this.edit = false
      this.items.push(this.formItem)
      var len = this.items.length
      this.activeNames = len
    },
    submitForm(index, formObj) {
      this.$refs.form[index].validate((valid) => {
        if (valid) {
          this.loading = true

          if (formObj.id != undefined) this.edit = true
          var action = 'all_stores/save'
          if (this.edit) {
            action = 'all_stores/edit'
          }
          this.$Progress.start()
          this.$store.dispatch(action, { 'url': this.url, 'data': formObj, 'slug': this.state })
            .then(response => {
              if (response.data.resource && response.data.resource.length > 0) {
                formObj.id = response.data.resource[0].id
                formObj.imms_uuid = response.data.resource[0].imms_uuid
              }
              this.$store.dispatch('toaster/add', { text: 'Save', type: 'success' })
              this.$Progress.finish()
              this.activeNames = -1
              this.loading = false
            })
            .catch(err => {
              this.$store.dispatch('toaster/add', { text: 'Error', type: 'success' })
              this.$Progress.fail()
              this.loading = false
            })
        }
        else {
          return false
        }
      })
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.nodeClear()
    },
    checkApplicable() {
      var action = 'applicable/save'
      var that = this
      var data = {}
      var message = 'Yes'
      data.family_members_canada = that.notApplicable
      data.application_id = this.$route.params.id
      data.member_id = parseFloat(this.memberID)
      data.member_uid = this.memberUID
      if (that.applicableId != undefined) {
        data.id = that.applicableId
        action = 'applicable/edit'
        message = 'No'
      }
      this.$Progress.start()
      this.$store.dispatch(action, data).then(response => {
        this.$store.dispatch('toaster/add', { text: message, type: 'success' })
        this.$Progress.finish()
      })
        .catch(err => {
          this.$store.dispatch('toaster/add', { text: 'No', type: 'success' })
          this.$Progress.fail()
        })
    }
  }
}
</script>
